import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';
import { rOyakKiraBilgileriUstBilgiYkgDetay } from '../../../../api/models/rOyakKiraBilgileriUstBilgiYkgDetay';
export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rOyakKiraBilgileriUstBilgiYkgDetay>,
  rOyakKiraBilgileriUstBilgiYkgDetay
>(
  ActionSubTypes.API_OYAKKIRABILGILERIUSTBILGIYKGDETAY,
  DefaultInputDataStateModel<pList, rOyakKiraBilgileriUstBilgiYkgDetay>()
);
